import type { ReactNode } from "react";

interface BadgeProps {
  variant?: "primary" | "accent" | "secondary" | "neutral" | "danger" | "warning";
  size?: "sm" | "md";
  children: ReactNode;
  className?: string;
}

export default function Badge({
  variant = "neutral",
  size = "sm",
  children,
  className = "",
}: BadgeProps) {
  const variants: Record<string, string> = {
    primary: "bg-primary-100 text-primary-800",
    accent: "bg-accent-100 text-accent-800",
    secondary: "bg-secondary-100 text-secondary-800",
    neutral: "bg-background-200 text-foreground-700",
    danger: "bg-red-100 text-red-800",
    warning: "bg-amber-100 text-amber-800",
  };

  const sizes: Record<string, string> = {
    sm: "text-xs px-2 py-0.5",
    md: "text-sm px-2.5 py-1",
  };

  return (
    <span
      className={`inline-flex items-center gap-1 font-medium rounded-full whitespace-nowrap ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {children}
    </span>
  );
}